import { useState } from "react"
import type { CreateFeatureDto, Feature, PluginspaceFeature, UpdateFeatureDto, ResponseCreateUpdate } from "../types"
import { DELETE, GET_ADM, POST_ADM, PUT_ADM    } from "../../../../services/api";
export function useFeaturesPluginsSpace() {
    const [features, setFeatures] = useState<Feature[]>([])

    async function getAllFeatures(): Promise<Feature[]> {
        try {
            const response = await GET_ADM(`/features`)
            if (!response.success) {
                setFeatures([])
                return []
            }
            setFeatures(response.data)
            return response.data
        } catch (error) {
            setFeatures([])
            return []
        }
    }

    async function createFeature(feature: CreateFeatureDto): Promise<ResponseCreateUpdate | null> {
        try {
            const response = await POST_ADM(`/features`, feature)
            if (!response.success) {
                return response
            }
            const newFeature = response.data
            setFeatures(prevFeatures => [...prevFeatures, newFeature])
            return response
        } catch (error) {
            return null
        }
    }

    async function updateFeature(id: number, feature: UpdateFeatureDto): Promise<ResponseCreateUpdate | null> {
        try {
            const response = await PUT_ADM(`/features/${id}`, feature)
            if (!response.success) {
                return response
            }
            const updatedFeature = response.data
            setFeatures(prevFeatures => prevFeatures.map(f => f.id === id ? updatedFeature : f))
            return response
        } catch (error) {
            return null
        }
    }

    async function deleteFeature(id: number): Promise<boolean> {
        try {
            const response = await DELETE(`/features/${id}`)
            if (!response?.success) {
                return false
            }

            setFeatures((prevFeatures) => prevFeatures.filter((feature) => feature.id !== id))
            return true
        } catch (error) {
            return false
        }
    }


    async function getAllFeaturesOfPluginspace(pluginspaceId: number): Promise<PluginspaceFeature[]> {
        const endpoints = [`/pluginspace-features/pluginspace/${pluginspaceId} `]

        for (const endpoint of endpoints) {
            try {
                const response = await GET_ADM(endpoint)
                if (response?.success) {
                    return response.data || []
                }
            } catch (error) {
                // tenta próximo endpoint
            }
        }

        return []
    }

    async function createFeatureForPluginspace(pluginspaceId: number, featureId: number): Promise<boolean> {
        const endpoints = [`/pluginspace-features`]

        for (const endpoint of endpoints) {
            try {
                const response = await POST_ADM(endpoint, { pluginspaceId, featureId })
                if (response?.success) {
                    return true
                }
            } catch (error) {
                // tenta próximo endpoint
            }
        }

        return false
    }

    async function removeFeatureForPluginspace(pluginspaceId: number, featureId: number): Promise<boolean> {
        const endpoints = [`/pluginspace-features/${pluginspaceId}/${featureId}`]

        for (const endpoint of endpoints) {
            try {
                const response = await DELETE(endpoint)
                if (response?.success) {
                    return true
                }
            } catch (error) {
                // tenta próximo endpoint
            }
        }

        return false
    }

    return {
        getAllFeatures,
        getAllFeaturesOfPluginspace,
        createFeatureForPluginspace,
        removeFeatureForPluginspace,
        features,
        updateFeature,
        deleteFeature,
        createFeature
    }
}